import "bootstrap/dist/css/bootstrap.min.css";
import 'tippy.js/dist/tippy.css'; //Styles for Tooltips
import 'tippy.js/themes/light.css';
import "./assets/css/animate.min.css";
import "./assets/css/demo.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";

import React from 'react';
import { createRoot } from 'react-dom/client';

import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';

import App from './App';
import configureStore from './store/configureStore';

import './i18n';
import unregisterServiceWorker from './unregisterServiceWorker';

import history from './history';
import { settingsActions } from "./store/Configuration";

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

store.dispatch(settingsActions.requestConfiguration());

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Provider store={store}>
  <ConnectedRouter history={history}>
    <App />
  </ConnectedRouter>
</Provider>);

unregisterServiceWorker();